import React, { useCallback, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { useLivePoll } from "../lib/live";
import { Card } from "../components/ui/card";
import { Mail, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function EmailIngestLog() {
  const [logs, setLogs] = React.useState([]);
  const [syncing, setSyncing] = useState(false);

  const load = useCallback(async () => {
    const { data } = await api.get("/email/ingest-log");
    setLogs(data || []);
  }, []);

  useLivePoll(load, 30000);

  const syncResend = async () => {
    setSyncing(true);
    try {
      const { data } = await api.post("/email/inbound/sync");
      const processed = data?.processed || 0;
      const skipped = data?.skipped || 0;
      const errors = data?.errors || 0;
      if (processed) toast.success(`${processed} e-mail(s) importado(s)`);
      else toast.info(`Nada novo para importar (${skipped} ignorados, ${errors} erros)`);
      await load();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Falha ao buscar e-mails no Resend");
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="email-ingest-page">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="font-display font-bold text-2xl flex items-center gap-2"><Mail size={22} /> E-mail cartório</h1>
          <p className="text-sm text-muted-foreground">
            Padrão: de thiagosdflausino@gmail.com para *@niatmarea.resend.app, assunto Intimações, anexo TXT.
          </p>
        </div>
        <Button type="button" variant="outline" onClick={syncResend} disabled={syncing}>
          <RefreshCw size={16} className={syncing ? "animate-spin" : ""} />
          {syncing ? "Buscando..." : "Buscar no Resend"}
        </Button>
      </div>
      <div className="space-y-2">
        {logs.map((l) => (
          <Card key={l.id} className="p-4 flex justify-between gap-4 text-sm">
            <div>
              <div className="font-medium">{l.subject || "(sem assunto)"}</div>
              <div className="text-muted-foreground">{l.from_email} · {l.attachment_name} · {l.format}</div>
              {l.error ? <div className="text-destructive mt-1">{l.error}</div> : null}
            </div>
            <div className="text-right">
              <span className="text-xs uppercase px-2 py-1 rounded bg-[var(--surface-2)]">{l.status}</span>
              <div className="text-xs text-muted-foreground mt-1">{new Date(l.created_at).toLocaleString()}</div>
            </div>
          </Card>
        ))}
        {!logs.length && <Card className="p-8 text-center text-muted-foreground">Nenhum e-mail processado ainda</Card>}
      </div>
    </div>
  );
}
